import { Component, OnInit } from '@angular/core';
import { ApplicationInfoService, RetrieveApplRequest } from 'app/applications/landing-page.service';
import { ApplicationInfoModel } from 'app/models/application-info.model';
import { FormService } from 'app/services/form.service';
import { UserProfileRecord } from 'app/users/user-profile-record';
import { UserService } from 'app/users/user.service';

@Component({
  selector: 'app-applicant-dashboard',
  templateUrl: './applicant-dashboard.component.html',
  styleUrls: ['./applicant-dashboard.component.scss']
})
export class ApplicantDashboardComponent implements OnInit {

  loadingComplete: boolean = false;
  private user!: UserProfileRecord;
  draftApplications!: ApplicationInfoModel[];
  get firstName() {
    return this.user?.firstName;
  }

  get lastName() {
    return this.user?.lastName;
  }

  get displayName() {
    return this.user?.displayName;
  }

  constructor(protected userService: UserService,
    private applicationInfoService: ApplicationInfoService,
    private formService: FormService
  ) {}

  ngOnInit() {
    this.user = this.userService.profile;
    if (this.userService.profile.orgId) { 
          const draftReq: RetrieveApplRequest = {
            orgId: this.userService.profile.orgId ?? '',
            ssoId: this.userService.profile.uniqueId ?? '',
            status: ["Draft"]
          };
          this.applicationInfoService.fetchApplicationsByStatus(draftReq).subscribe({
            next: (response) => {
              let data = response.Data;
              if (data) {
                this.draftApplications = this.applicationInfoService.mapToApplicationModelArray(data, 'Draft');
              }
              this.loadingComplete = true;
            },
            error: (err) => {
              console.log("Fetching Applications Error - " + err);
              this.loadingComplete = true;
            }
          });

      //retrieve user org name
      this.formService.retrieveOrgName();
    }
  }

}
